var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.memberId !== _setup.userStore.memberId && _setup.itemStore.likedItemIds.includes(_vm.itemId))?_c(_setup.FollowRecommend,{attrs:{"member-id":_vm.memberId,"placement":"bottom-end"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }